'use strict';

var LogConfig = function LogConfig($location, $log) {
  var query = $location.search();
  if (query.debug) {
    $log.debugEnabled(true);
  }
};
LogConfig.$inject = ['$location', '$log'];
module.exports = LogConfig;